import Base from './base/index';

const ConversationService = {};

export default {
  ...Base,
  ...ConversationService,
};
